import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmptyState = ({ title, description, actionLabel, onAction, iconName }) => {
  return (
    <div className="flex flex-col items-center justify-center py-12 md:py-16 lg:py-20 px-4">
      <div className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-muted flex items-center justify-center mb-4 md:mb-6">
        <Icon name={iconName || 'AlertCircle'} size={32} className="text-muted-foreground" />
      </div>
      <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground mb-2 text-center">
        {title}
      </h3>
      <p className="text-sm md:text-base text-muted-foreground text-center max-w-md mb-6 md:mb-8">
        {description}
      </p>
      {actionLabel && onAction && (
        <Button variant="default" onClick={onAction}>
          {actionLabel}
        </Button>
      )}
    </div>
  );
};

export default EmptyState;